import _uniqBy from 'lodash/uniqBy'
import { DealerConfigureServiceEventArguments } from '@racepointenergy/swc/scs/dealer-configure-service-event'
import type { HomeId } from '@racepointenergy/swc/scs/types'
import type { ServiceState } from '@racepointenergy/swc/scs/features/host-states'
import type { Service } from '@racepointenergy/swc/scs/features/host-services'

import type { DropdownOption } from 'components/Input/Dropdown'
import type { HomeServicesEvent } from './types'
import { ALL_TYPES_JSON_FILENAME } from './consts'

export function getFilterOptions(
  defaultOption: DropdownOption,
  services: (Service | undefined)[],
  filteringField: keyof Service
) {
  if (!services) {
    return []
  }
  const rawFilterOptions = services.map((service) => ({
    label: `${service?.[filteringField]}`,
    value: `${service?.[filteringField]}`,
  }))

  return _uniqBy([defaultOption].concat(rawFilterOptions), 'value')
}

export function getEventData(
  homeId: HomeId,
  values: HomeServicesEvent,
  services: ServiceState[]
): DealerConfigureServiceEventArguments {
  const service = services.find((service) => service.id === values.serviceId)
  const serviceType =
    values.serviceType === ALL_TYPES_JSON_FILENAME
      ? undefined
      : values.serviceType

  return {
    id: homeId,
    component: service?.component,
    logicalComponent: service?.logicalComponent,
    params: values.arguments
      ?.filter((arg) => arg.name)
      .map((arg) => ({ [arg.name]: arg.value })),
    request: values.event || undefined,
    serviceType: serviceType || undefined,
    variant: service?.variant,
    zone: values.zone || undefined,
  }
}
